import { call, put, takeEvery } from "redux-saga/effects";
import {
  premiumCalculatePostError,
  premiumCalculatePostSuccess,
} from "./actions";
import { PREMIUM_CALCULATE } from "./actionTypes";
import { postPremiumCalculate } from "../../resources/helper/premiumCalculation";

const serializeError = (error) => {
  if (!error) return null;

  if (typeof error === "object") {
    return {
      ...error,
      message: error.message,
      name: error.name,
      stack: error.stack,
    };
  }

  return error;
};

function* premiumCalculatePost({ payload: { calculateBody } }) {
  try {
    const response = yield call(postPremiumCalculate, calculateBody);
    yield put(premiumCalculatePostSuccess(response));
  } catch (error) {
    const serializedError = serializeError(error);
    console.log("Error serializado para Redux:", serializedError);
    yield put(premiumCalculatePostError(serializedError));
  }
}

function* PremiumCalculateSaga() {
  yield takeEvery(PREMIUM_CALCULATE, premiumCalculatePost);
}

export default PremiumCalculateSaga;
